import { z } from 'zod';

export const ReportingShellUrlParamSchema = z.object({
    overlay: z.enum(['workspace', 'account']).optional(),
});
